module.exports = __webpack_public_path__ + "img/monetizze.85e4a584.png";